import { CopyIcon } from '@phosphor-icons/react';
import * as React from 'react';
import { css, html } from 'react-strict-dom';
import { color } from 'src/constants/color.css';

import { Text } from '../../../components';
import { Color, Style } from '../../../constants';

type Props = {
  value: string;
  label: string;
  copied: boolean;
  onCopy: () => void;
  typeface?: 'body.medium' | 'body.small.medium';
};

export default function CopyableText({
  value,
  label,
  copied,
  onCopy,
  typeface = 'body.medium',
}: Props) {
  const [hover, setHover] = React.useState(false);
  const active = hover || copied;

  return (
    <html.div style={[Style.row, Style.alignCenter, styles.row]}>
      <html.div
        style={[
          Style.row,
          Style.alignCenter,
          styles.pill,
          active && styles.pillActive,
        ]}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onClick={onCopy}
      >
        <Text typeface={typeface} color="neutral100" style={styles.value}>
          {value}
        </Text>
        <html.button
          type="button"
          style={[styles.copyBtn, !active && styles.copyHidden]}
          aria-label={label}
        >
          <CopyIcon size={20} color={Color.neutral60} />
        </html.button>
      </html.div>
      {copied && (
        <Text typeface="body.small.regular" color="neutral60">
          Copied
        </Text>
      )}
    </html.div>
  );
}

const styles = css.create({
  row: {
    gap: 8,
  },
  pill: {
    gap: 8,
    minWidth: 0,
    flexShrink: 1,
    padding: 10,
    borderRadius: 8,
    cursor: 'pointer',
    backgroundColor: 'transparent',
    transition: 'background-color 0.15s',
  },
  // Long usernames/passwords wrap inside the card instead of overflowing it
  // (M10C-QA-047).
  value: {
    minWidth: 0,
    flexShrink: 1,
    overflowWrap: 'anywhere',
  },
  pillActive: {
    backgroundColor: color.neutral20,
  },
  copyBtn: {
    display: 'flex',
    borderWidth: 0,
    backgroundColor: 'transparent',
    cursor: 'pointer',
    padding: 0,
    transition: 'opacity 0.15s',
  },
  copyHidden: {
    opacity: 0,
  },
});
